/**
 * 叫号屏模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取设备列表
export const getDeviceList = (params) => {
  return req.get('/deptDevice/select', params);
}
// 新增设备
export const addDevice = (params) => {
  return req.post('/deptDevice/add', params);
}
// 删除设备
export const delDevice = (params) => {
  return req.get('/deptDevice/delete', params);
}
// 更新设备
export const updateDevice = (params) => {
  return req.post('/deptDevice/update', params);
}
// 获取关联诊室列表
export const getDeviceRoomsList = (params) => {
  return req.get('/deptDevice/selectRooms', params);
}
// 更新设备关联诊室
export const updateDeviceRooms = (params) => {
  return req.post('/deptDevice/updateRooms', params);
}
